import { createClass } from "asteroid";

const Asteroid = createClass();
const current_location = window.location.href;
let force_production_mode =
  current_location.search("//eprezto.com") > 0 ||
  current_location.search("//www.eprezto.com") > 0 ||
  current_location.search("//dev.eprezto.com") > 0;

/* Force to use in localhost */
/* SOLO COMENTAR O DESCOMENTAR LA VARIABLE, NO EDITARLA */
// force_production_mode = true;
const asteroid = new Asteroid({
  /* Online Production */
  /* endpoint: "wss://server.aloseguro.com/websocket" */
  /* endpoint: "wss://apollo.eprezto.com/websocket" */

  /* Online Development */
  // endpoint: "wss://apollo.eprezto.com/websocket" 

  /* Local Development */
  endpoint: force_production_mode
  ? "wss://apollo.eprezto.com/websocket"
  : "ws://localhost:3002/websocket"
});

console.log("Actual End Point:", asteroid.endpoint);

export default asteroid;
